import { useEffect, useState } from "react";
import {
  FormCard,
  FormDialog,
  FormField,
  FormGrid,
  FormSection,
} from "@NP-Webber/crm-kit";
import "@NP-Webber/crm-kit/dist/formkit/FormKit.css";
import type { MeetingAgendaItem } from "../../../api/meetingsApi";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (payload: { title: string; notes: string | null }) => Promise<void>;
  initial?: MeetingAgendaItem | null;
};

export function AgendaItemDialog({ open, onClose, onSave, initial }: Props) {
  const [form, setForm] = useState({ title: "", notes: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    setForm({
      title: initial?.title || "",
      notes: initial?.notes || "",
    });
  }, [open, initial]);

  const set = (field: "title" | "notes", value: string) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    if (!form.title.trim()) {
      setError("יש להזין כותרת נושא");
      return;
    }
    setSaving(true);
    try {
      await onSave({ title: form.title.trim(), notes: form.notes.trim() || null });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "שגיאה");
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormDialog open={open} onClose={onClose} size="sm">
      <FormCard
        title={initial?.id ? "עריכת נושא" : "הוספת נושא לסדר יום"}
        error={error}
        onSave={() => {
          void handleSave();
        }}
        onCancel={onClose}
        saving={saving}
        saveLabel="שמור"
        cancelLabel="ביטול"
      >
        <FormSection title="פרטי הנושא">
          <FormGrid cols={1}>
            <FormField
              label="נושא"
              required
              value={form.title}
              onChange={(v) => set("title", v)}
            />
            <FormField
              label="הערות / נקודות לדיון"
              value={form.notes}
              onChange={(v) => set("notes", v)}
              rows={3}
            />
          </FormGrid>
        </FormSection>
      </FormCard>
    </FormDialog>
  );
}
